import { NEW_TAB_TARGET } from './constants'
import type { WhatsAppLinkData } from './linksDataTypes'
import type { Link } from '@wix/public-schemas'

export const WHATSAPP_LINK_PREFIX = `https://api.whatsapp.com/send?phone=`

export const handleWhatsAppLink = (linkData: WhatsAppLinkData): Link => {
	const { phoneNumber } = linkData
	const sanitizedPhoneNumber = phoneNumber.replace(new RegExp('[+|-]', 'g'), '')
	return { id: linkData.id, href: `${WHATSAPP_LINK_PREFIX}${sanitizedPhoneNumber}`, target: NEW_TAB_TARGET }
}
